var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./MembersPopup.jinja');
require('./MembersPopup.less');

var MemberProfile = require('front/components/MemberProfile/MemberProfile');

module.exports = BasePopup.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        // 'MemberProfile': {selector: '.MemberProfile', viewConstructor: MemberProfile}
    },


    events: _.extend({
    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        return Urls['member:api:member'](this.memberId, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        this.showLoader = true;

        //disable cache for apiUrl
        this.disableCache = true;

        this.memberId = this.options.slug.split('-')[0] - 0;

        // if (window.app.data.memberPopupId && window.app.settings.member &&
        //     window.app.data.memberPopupId !== this.memberId && this.memberId == window.app.settings.member ) {
        //     console.log('reload');
        // }
        // window.app.data.memberPopupId = this.memberId;

        BasePopup.prototype.initialize.call(this, options);
    },


    //override base.js logic, because aip return data without 'popup' wrapper (special case for members)
    proceedDataOnLoad: function (data) {
        this.data = {
            popup: data
        };
    },


    activate: function () {

        return BasePopup.prototype.activate.call(this)
            .then(function () {

                //if data is not from server  render, but from xhr request
                //save for future use as if it's getted from serverside render to unify all data usage processes
                if (this.data && this.data.popup && this.data.popup.id) {
                    window.app.data.members = window.app.data.members || {};
                    window.app.data.members[this.data.popup.id] = JSON.parse(JSON.stringify(this.data.popup));//deep clone object
                }

                this.MemberProfile = new MemberProfile({
                    el: $('.MemberProfile')[0],
                    memberId: this.memberId
                });

                this.MemberProfile.activate();
            }.bind(this));
    },


    deactivate: function (params) {
        this.MemberProfile && this.MemberProfile.deactivate();
        delete this.MemberProfile;

        return BasePopup.prototype.deactivate.call(this, params);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MembersPopup/MembersPopup.js
// module id = 279
// module chunks = 0